import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 py-3" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-950 no-underline"
        >
          <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <i className="ri-book-open-line text-white text-lg"></i>
          </span>
          <span className="font-heading font-bold text-xl whitespace-nowrap">虫虫漫画</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === link.href
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line"></i>
          </button>
          <Link
            to="/category/all"
            className="bg-primary-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="mt-2 bg-primary-500 text-white px-4 py-3 rounded-lg text-sm font-medium text-center hover:bg-primary-600 transition-colors"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}